'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/objectSpread");

var _awaitAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncIterator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var multipartRequest = require('ipfs-core-utils/multipart-request');

var abortSignal = require('../lib/abort-signal.js');

var toString = require('uint8arrays/to-string');

var mapEvent = require('./map-event.js');

var createPut = configure.configure(function (api) {
  function put(_x, _x2) {
    return _put.apply(this, arguments);
  }

  function _put() {
    _put = _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(key, value) {
      var options,
          controller,
          signal,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          event,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              controller = new AbortController();
              signal = abortSignal.abortSignal(controller.signal, options.signal);
              _context.t0 = _awaitAsyncGenerator;
              _context.t1 = api;
              _context.t2 = _objectSpread;
              _context.t3 = {
                signal: signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({
                  arg: key instanceof Uint8Array ? toString.toString(key) : key.toString()
                }, options))
              };
              _context.next = 9;
              return _awaitAsyncGenerator(multipartRequest.multipartRequest([value], controller, options.headers));

            case 9:
              _context.t4 = _context.sent;
              _context.t5 = (0, _context.t2)(_context.t3, _context.t4);
              _context.t6 = _context.t1.post.call(_context.t1, 'dht/put', _context.t5);
              _context.next = 14;
              return (0, _context.t0)(_context.t6);

            case 14:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 17;
              _iterator = _asyncIterator(res.ndjson());

            case 19:
              _context.next = 21;
              return _awaitAsyncGenerator(_iterator.next());

            case 21:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 25;
              return _awaitAsyncGenerator(_step.value);

            case 25:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 33;
                break;
              }

              event = _value;
              _context.next = 30;
              return mapEvent.mapEvent(event);

            case 30:
              _iteratorNormalCompletion = true;
              _context.next = 19;
              break;

            case 33:
              _context.next = 39;
              break;

            case 35:
              _context.prev = 35;
              _context.t7 = _context["catch"](17);
              _didIteratorError = true;
              _iteratorError = _context.t7;

            case 39:
              _context.prev = 39;
              _context.prev = 40;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 44;
                break;
              }

              _context.next = 44;
              return _awaitAsyncGenerator(_iterator.return());

            case 44:
              _context.prev = 44;

              if (!_didIteratorError) {
                _context.next = 47;
                break;
              }

              throw _iteratorError;

            case 47:
              return _context.finish(44);

            case 48:
              return _context.finish(39);

            case 49:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 35, 39, 49], [40,, 44, 48]]);
    }));
    return _put.apply(this, arguments);
  }

  return put;
});
exports.createPut = createPut;